
import { supabase } from "@/integrations/supabase/client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@/hooks/use-toast";
import { UpdateParcelData, Parcel } from "./types";

/**
 * Hook to update an existing parcel
 */
export const useUpdateParcel = () => {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: async ({ id, ...parcelData }: UpdateParcelData) => {
      const { data, error } = await supabase
        .from('parcels')
        .update(parcelData)
        .eq('id', id)
        .select('*')
        .single();

      if (error) throw error;

      return data as Parcel;
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['parcels'] });
      queryClient.invalidateQueries({ queryKey: ['parcels', data.id] });
      toast({
        title: "Parcelle mise à jour",
        description: "Votre parcelle a été modifiée avec succès."
      });
    },
    onError: (error: Error) => {
      toast({
        title: "Erreur",
        description: error.message || "Une erreur est survenue lors de la mise à jour de la parcelle.",
        variant: "destructive"
      });
    }
  });
};
